import { progress, photoCollection, checkCircle, homedayLogo, turnOff } from 'homeday-assets';
import { DEALS as DEALS_ROUTE_NAMES } from '@/router/wizard/ROUTE_NAMES';
import USER_ROUTE_NAMES from '@/router/user/ROUTE_NAMES';
import SCANNER_ROUTE_NAMES from '@/router/scanner/ROUTE_NAMES';
import DASHBOARD_ROUTE_NAMES from '@/router/dashboard/ROUTE_NAMES';

export const BURGER_MENU_NAVIGATION = [
  {
    title: 'GENERAL.MY_REAL_ESTATE',
    children: [
      {
        // TODO: use this icon from homeday-assets once it's available
        icon: require('@/assets/icons/kanban.svg'),
        label: 'GENERAL.DETAILED_VIEW',
        routeName: DASHBOARD_ROUTE_NAMES.DASHBOARD,
      },
      {
        icon: photoCollection,
        label: 'GENERAL.DOCUMENTS_SCANNER',
        routeName: SCANNER_ROUTE_NAMES.SCAN_DOCUMENTS,
      },
    ],
  },
  {
    title: 'GENERAL.PRICE_ASSISTANT',
    children: [
      {
        icon: progress,
        label: 'WIZARD.LIST.MENU.FUTURE_DEALS',
        routeName: DEALS_ROUTE_NAMES.FUTURE_DEALS,
      },
      {
        icon: checkCircle,
        label: 'WIZARD.LIST.MENU.PAST_DEALS',
        routeName: DEALS_ROUTE_NAMES.PAST_DEALS,
      },
    ],
  },
  {
    title: 'GENERAL.EXTERNAL_LINKS',
    children: [
      {
        icon: homedayLogo,
        label: 'GENERAL.DOCUMENTATION',
        link: 'https://wiki.homeday.de/hc/de/categories/12081543637522-Makler-App',
      },
      {
        icon: checkCircle,
        label: 'GENERAL.CONNECT',
        link: 'https://app.homeday.de/crm/dashboard',
      },
    ],
  },
  {
    title: 'ACCOUNT_CONTROLS.TITLE',
    children: [
      {
        icon: turnOff,
        label: 'ACCOUNT_CONTROLS.LOGOUT',
        routeName: USER_ROUTE_NAMES.LOGOUT,
      },
    ],
  },
];
